import { fetchAll } from './fetch';
import Family from 'models/family';

export default fetchAll('family', Family, []);
